// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Numero d'une ligne du tableau « Commandes complementaires ». */
.tab-complements__courante {
  font-weight: 600;
}

.tab-complements__lien {
  color: #374151;
  text-decoration: underline;
  cursor: pointer;
}

/* Bon lie que l'utilisateur ne peut pas ouvrir : visible mais en retrait, avec la raison dessous. */
.tab-complements__ferme {
  opacity: 0.6;
  cursor: default;
}

.tab-complements__ferme small {
  display: block;
  font-size: 0.8em;
}
`, "",{"version":3,"sources":["webpack://./src/composants/TableauComplements/TableauComplements.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,oGAAoG;AACpG;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Numero d'une ligne du tableau « Commandes complementaires ». */\n.tab-complements__courante {\n  font-weight: 600;\n}\n\n.tab-complements__lien {\n  color: #374151;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Bon lie que l'utilisateur ne peut pas ouvrir : visible mais en retrait, avec la raison dessous. */\n.tab-complements__ferme {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.tab-complements__ferme small {\n  display: block;\n  font-size: 0.8em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
